<ds-container>
  <ds-row>
    <ds-col span-xs="3" span-md="3"></ds-col>
    <ds-col span-xs="6" span-md="6">
      <ds-empty-state
        class="empty-state-centered"
        compact
        icon="action-clear"
        headline="You are not authorized to access this resource"
      ></ds-empty-state>
    </ds-col>
    <ds-col span-xs="3" span-md="3"></ds-col>
  </ds-row>
</ds-container>
